// extracted by mini-css-extract-plugin
export default {"dropzone":"CreateCollection_dropzone__gEYuQ"};